import { apiPaths, type NowResponse, type StopsResponse } from '../../../shared/api/contract.ts';
import { DEFAULT_CITY } from '../../../shared/cities/index.ts';
import { FRESHNESS_POLICIES } from '../../../shared/freshness/index.ts';
import { DemoBanner } from '../../components/Banners.tsx';
import { PageHeader } from '../../components/PageHeader.tsx';
import { useApi } from '../../hooks/useApi.ts';
import { TodayTimeline } from '../timeline/TodayTimeline.tsx';
import { DeparturesBoard } from '../transport/DeparturesBoard.tsx';
import { CityMapPanel } from './CityMapPanel.tsx';
import { ConditionsRow } from './ConditionsRow.tsx';
import { DailyRow } from './DailyRow.tsx';
import { Hero } from './Hero.tsx';
import { LocalNews } from './LocalNews.tsx';
import { SunsetCard } from './SunsetCard.tsx';

/**
 * Accueil : hero bord à bord, conditions du moment, puis grille 2 × 2 sur desktop
 * (départs | carte, aujourd'hui | actualités + ciel). Sur mobile, une colonne dans le même ordre.
 */
export function HomePage() {
  const city = DEFAULT_CITY.slug;
  const now = useApi<NowResponse>(apiPaths.now(city), FRESHNESS_POLICIES.weather.refreshMs);
  const stops = useApi<StopsResponse>(apiPaths.stops(city));
  const demo =
    now.data !== undefined &&
    [now.data.weather, now.data.nowcast, now.data.airQuality, now.data.network, now.data.alerts].some((s) => s.demo);

  return (
    <>
      {/* Balises de la page ; le titre visible est dans le hero. */}
      <PageHeader path="/" showHeading={false} />
      <Hero />
      <div className="container home">
        {demo && <DemoBanner />}
        <ConditionsRow data={now.data} lines={stops.data?.lines} />
        <DailyRow />
        <div className="home-grid">
          <DeparturesBoard limit={4} showMoreLink className="home-grid__departures" />
          <CityMapPanel />
          <div id="aujourdhui" className="home-grid__today">
            <TodayTimeline />
          </div>
          <div className="home-grid__stack">
            <LocalNews />
            <SunsetCard />
          </div>
        </div>
      </div>
    </>
  );
}
